import { Skeleton } from 'antd';
import React from 'react';

const ReferralsSkeleton = () => {
  return (
    <div className="referrals-page" style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
      {/* Header skeleton */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Skeleton.Avatar size={64} active style={{ marginBottom: '16px' }} />
        <Skeleton.Input style={{ width: 300, marginBottom: '12px' }} active />
        <Skeleton.Input style={{ width: 400, marginBottom: '20px' }} active />
        <Skeleton.Button style={{ width: 200 }} active />
      </div>

      {/* Invite section skeleton */}
      <div style={{ 
        background: 'var(--bg-secondary)', 
        borderRadius: '12px', 
        padding: '24px',
        marginBottom: '32px',
        border: '1px solid var(--border-subtle)'
      }}>
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>

      {/* Table skeleton */}
      <div>
        <Skeleton.Input style={{ width: 150, marginBottom: '16px' }} active />
        <Skeleton active paragraph={{ rows: 5 }} />
      </div>
    </div>
  );
};

export default ReferralsSkeleton;
